export default "__VITE_ASSET__BVhJA5JE__"